/**
 * @todo component for UI-Kit
 */
import React from 'react';

import styles from './loader.module.css';

export default ({color = '#212121'}) => <div className={styles.loader} style={{borderTopColor: color}} />;
